/* eslint-disable */
export const isHex = (hex) => typeof hex === 'string' && /#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(hex);
export const isRgb = (rgb) => (typeof rgb === 'object' && rgb.r && rgb.g && rgb.b) || /(\d{1,3},\s?\d{1,3},\s?\d{1,3})/.test(rgb);
export const isHsl = (hsl) => (typeof hsl === 'object' && hsl.h && hsl.s && hsl.l) || /(([\d\.]{1,3},\s?[\d\.]{1,3},\s?[\d\.]{1,3}))/.test(hsl);

const BROWSER_COLORS = {
  'black':'#000000',
  'navy':'#000080',
  'darkblue':'#00008b',
  'mediumblue':'#0000cd',
  'blue':'#0000ff',
  'darkgreen':'#006400',
  'green':'#008000',
  'teal':'#008080',
  'darkcyan':'#008b8b',
  'deepskyblue':'#00bfff',
  'darkturquoise':'#00ced1',
  'mediumspringgreen':'#00fa9a',
  'lime':'#00ff00',
  'springgreen':'#00ff7f',
  'aqua':'#00ffff',
  'cyan':'#00ffff',
  'midnightblue':'#191970',
  'dodgerblue':'#1e90ff',
  'lightseagreen':'#20b2aa',
  'forestgreen':'#228b22',
  'seagreen':'#2e8b57',
  'darkslategray':'#2f4f4f',
  'darkslategrey':'#2f4f4f',
  'limegreen':'#32cd32',
  'mediumseagreen':'#3cb371',
  'turquoise':'#40e0d0',
  'royalblue':'#4169e1',
  'steelblue':'#4682b4',
  'darkslateblue':'#483d8b',
  'mediumturquoise':'#48d1cc',
  'indigo':'#4b0082',
  'darkolivegreen':'#556b2f',
  'cadetblue':'#5f9ea0',
  'cornflowerblue':'#6495ed',
  'rebeccapurple':'#663399',
  'mediumaquamarine':'#66cdaa',
  'dimgray':'#696969',
  'dimgrey':'#696969',
  'slateblue':'#6a5acd',
  'olivedrab':'#6b8e23',
  'slategray':'#708090',
  'slategrey':'#708090',
  'lightslategray':'#778899',
  'lightslategrey':'#778899',
  'mediumslateblue':'#7b68ee',
  'lawngreen':'#7cfc00',
  'chartreuse':'#7fff00',
  'aquamarine':'#7fffd4',
  'maroon':'#800000',
  'purple':'#800080',
  'olive':'#808000',
  'gray':'#808080',
  'grey':'#808080',
  'skyblue':'#87ceeb',
  'lightskyblue':'#87cefa',
  'blueviolet':'#8a2be2',
  'darkred':'#8b0000',
  'darkmagenta':'#8b008b',
  'saddlebrown':'#8b4513',
  'darkseagreen':'#8fbc8f',
  'lightgreen':'#90ee90',
  'mediumpurple':'#9370db',
  'darkviolet':'#9400d3',
  'palegreen':'#98fb98',
  'darkorchid':'#9932cc',
  'yellowgreen':'#9acd32',
  'sienna':'#a0522d',
  'brown':'#a52a2a',
  'darkgray':'#a9a9a9',
  'darkgrey':'#a9a9a9',
  'lightblue':'#add8e6',
  'greenyellow':'#adff2f',
  'paleturquoise':'#afeeee',
  'lightsteelblue':'#b0c4de',
  'powderblue':'#b0e0e6',
  'firebrick':'#b22222',
  'darkgoldenrod':'#b8860b',
  'mediumorchid':'#ba55d3',
  'rosybrown':'#bc8f8f',
  'darkkhaki':'#bdb76b',
  'silver':'#c0c0c0',
  'mediumvioletred':'#c71585',
  'indianred':'#cd5c5c',
  'peru':'#cd853f',
  'chocolate':'#d2691e',
  'tan':'#d2b48c',
  'lightgray':'#d3d3d3',
  'lightgrey':'#d3d3d3',
  'thistle':'#d8bfd8',
  'orchid':'#da70d6',
  'goldenrod':'#daa520',
  'palevioletred':'#db7093',
  'crimson':'#dc143c',
  'gainsboro':'#dcdcdc',
  'plum':'#dda0dd',
  'burlywood':'#deb887',
  'lightcyan':'#e0ffff',
  'lavender':'#e6e6fa',
  'darksalmon':'#e9967a',
  'violet':'#ee82ee',
  'palegoldenrod':'#eee8aa',
  'lightcoral':'#f08080',
  'khaki':'#f0e68c',
  'aliceblue':'#f0f8ff',
  'honeydew':'#f0fff0',
  'azure':'#f0ffff',
  'sandybrown':'#f4a460',
  'wheat':'#f5deb3',
  'beige':'#f5f5dc',
  'whitesmoke':'#f5f5f5',
  'mintcream':'#f5fffa',
  'ghostwhite':'#f8f8ff',
  'salmon':'#fa8072',
  'antiquewhite':'#faebd7',
  'linen':'#faf0e6',
  'lightgoldenrodyellow':'#fafad2',
  'oldlace':'#fdf5e6',
  'red':'#ff0000',
  'fuchsia':'#ff00ff',
  'magenta':'#ff00ff',
  'deeppink':'#ff1493',
  'orangered':'#ff4500',
  'tomato':'#ff6347',
  'hotpink':'#ff69b4',
  'coral':'#ff7f50',
  'darkorange':'#ff8c00',
  'lightsalmon':'#ffa07a',
  'orange':'#ffa500',
  'lightpink':'#ffb6c1',
  'pink':'#ffc0cb',
  'gold':'#ffd700',
  'peachpuff':'#ffdab9',
  'navajowhite':'#ffdead',
  'moccasin':'#ffe4b5',
  'bisque':'#ffe4c4',
  'mistyrose':'#ffe4e1',
  'blanchedalmond':'#ffebcd',
  'papayawhip':'#ffefd5',
  'lavenderblush':'#fff0f5',
  'seashell':'#fff5ee',
  'cornsilk':'#fff8dc',
  'lemonchiffon':'#fffacd',
  'floralwhite':'#fffaf0',
  'snow':'#fffafa',
  'yellow':'#ffff00',
  'lightyellow':'#ffffe0',
  'ivory':'#fffff0',
  'white':'#ffffff'
}

const sbcRip = (d) => {
  var l=d.length,RGB={};
  if(l>9){
    d=d.split(',');
    if(d.length<3||d.length>4)return null;//ErrorCheck
    RGB[0]=parseInt(d[0].slice(4));
    RGB[1]=parseInt(d[1]);
    RGB[2]=parseInt(d[2]);
    RGB[3]=d[3]?parseFloat(d[3]):-1;
  }else{
    if(l==8||l==6||l<4)return null; //ErrorCheck
    if(l<6)d='#'+d[1]+d[1]+d[2]+d[2]+d[3]+d[3]+(l>4?d[4]+''+d[4]:''); //3 digit
    d=parseInt(d.slice(1),16);
    RGB[0]=d>>16&255;
    RGB[1]=d>>8&255;
    RGB[2]=d&255;
    RGB[3]=l==9||l==5?Math.round(((d>>24&255)/255)*10000)/10000:-1;
  }
  return RGB;
};

export const shadeBlendConvert = (p, from, to) => {
  if(typeof(p)!='number'||p<-1||p>1||typeof(from)!='string'||(from[0]!='r'&&from[0]!='#')||(typeof(to)!='string'&&typeof(to)!='undefined'))return from; //ErrorCheck
  var i=parseInt,r=Math.round,h=from.length>9,h=typeof(to)=='string'?to.length>9?true:to=='c'?!h:false:h,b=p<0,p=b?p*-1:p,to=to&&to!='c'?to:b?'#000000':'#FFFFFF',f=sbcRip(from),t=sbcRip(to);
  if(!f||!t)return from; //ErrorCheck
  if(h)return 'rgb('+r((t[0]-f[0])*p+f[0])+','+r((t[1]-f[1])*p+f[1])+','+r((t[2]-f[2])*p+f[2])+(f[3]<0&&t[3]<0?')':','+(f[3]>-1&&t[3]>-1?r(((t[3]-f[3])*p+f[3])*10000)/10000:t[3]<0?f[3]:t[3])+')');
  else return '#'+(0x100000000+(f[3]>-1&&t[3]>-1?r(((t[3]-f[3])*p+f[3])*255):t[3]>-1?r(t[3]*255):f[3]>-1?r(f[3]*255):255)*0x1000000+r((t[0]-f[0])*p+f[0])*0x10000+r((t[1]-f[1])*p+f[1])*0x100+r((t[2]-f[2])*p+f[2])).toString(16).slice(f[3]>-1||t[3]>-1?1:3);
};

export const luminanace = (r, g, b) => {
  const a = [r,g,b].map(function(v) {
    v /= 255;
    return (v <= 0.03928) ?
      v / 12.92 :
      Math.pow( ((v+0.055)/1.055), 2.4 );
  });
  return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
};

export const isLight = (rgb, threshold=127.5) => {
  rgb = normalizeColor(rgb);

  const hsp = Math.sqrt( // HSP equation from http://alienryderflex.com/hsp.html
    0.299 * (rgb.r * rgb.r) +
    0.587 * (rgb.g * rgb.g) +
    0.114 * (rgb.b * rgb.b)
  );

  return hsp >= threshold;
};

export const rgbToRgb = (rgb, toString = false) => {
  if (typeof rgb === 'string') {
    const matches = /([0-9]{1,3})[\s\,]+([0-9]{1,3})[\s\,]+([0-9]{1,3})/.exec(rgb);
    if (!matches) {
      throw new Error('Rgb must be atleast 3 sets of 3 comma seperated integers');
    }

    rgb = {
      r:Math.max(0, Math.min(255, parseInt(matches[1] || '0'))),
      g:Math.max(0, Math.min(255, parseInt(matches[2] || '0'))),
      b:Math.max(0, Math.min(255, parseInt(matches[3] || '0'))),
      a:Math.max(0, Math.min(1, parseFloat(matches[4] || '1')))
    };
  }

  return toString ? `rgba(${rgb.a},${rgb.g},${rgb.b},${rgb.a || 1})` : rgb;
};

export const hslToHsl = (hsl) => {
  const matches = /([\d\.]{1,3})[\s\,]+([\d\.]{1,3})[\s\,]+([\d\.]{1,3})/.exec(hsl);
  if (!matches) {
    throw new Error('HSL must be atleast 3 sets of 3 comma seperated floats');
  }
  return {
    h:Math.max(0, Math.min(360, parseFloat(matches[1] || '0'))),
    s:Math.max(0, Math.min(100, parseFloat(matches[2] || '0'))),
    l:Math.max(0, Math.min(100, parseFloat(matches[3] || '0'))),
    a:1
  };
};

export const normalizeHex = (hex) => {
  return `000${hex}`.slice(-2);
};

export const rgbToHex = (rgb) => {
  if (!rgb) return;

  if (typeof rgb === 'string') {
    rgb = rgbToRgb(rgb);
  }
  return `#${normalizeHex(parseInt(rgb.r, 10).toString(16))}${normalizeHex(parseInt(rgb.g, 10).toString(16))}${normalizeHex(parseInt(rgb.b, 10).toString(16))}`;
};

const hexMap = {};
export const hexToRgb = (hex, toString = false) => {
  let out = hexMap[hex];
  if (!out) {
    hex = hex.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, function(m, r, g, b) {
      return r + r + g + g + b + b;
    });

    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

    out = {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16),
      a: 1
    };
  }

  return toString ? `rgb(${out.r},${out.g},${out.b})` : out;
};

export const hue2rgb = (p, q, t) =>{
  if(t < 0) t += 1;
  if(t > 1) t -= 1;
  if(t < 1/6) return p + (q - p) * 6 * t;
  if(t < 1/2) return q;
  if(t < 2/3) return p + (q - p) * (2/3 - t) * 6;
  return p;
};

export const hslToRgb = (hsl, toString = false) => {
  const { h, s, l } = hslToHsl(hsl);

  let r, g, b;

  if(s == 0){
    r = g = b = l; // achromatic
  }else{
    var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    var p = 2 * l - q;
    r = hue2rgb(p, q, h + 1/3);
    g = hue2rgb(p, q, h);
    b = hue2rgb(p, q, h - 1/3);
  }

  const out = {
    r: Math.round(r * 255),
    g: Math.round(g * 255),
    b: Math.round(b * 255)
  };

  return toString ? `rgb(${out.r}, ${out.g}, ${out.b})` : out;
};

export const rgbToHsl = (rgb, toString = false) =>{
  let { r, g, b } = rgbToRgb(rgb);

  r /= 255; g /= 255; b /= 255;
  const max = Math.max(r, g, b), min = Math.min(r, g, b);
  let h, s, l = (max + min) / 2;

  if(max == min){
    h = s = 0; // achromatic
  }else{
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch(max){
    case r: h = (g - b) / d + (g < b ? 6 : 0); break;
    case g: h = (b - r) / d + 2; break;
    case b: h = (r - g) / d + 4; break;
    }
    h /= 6;
  }

  return toString ? `hsl(${h},${s},${l})` : {h,s,l};
};

export const normalizeColor = (value, toString) => {
  if (!value) return;
  
  if (BROWSER_COLORS[value.toLowerCase()]) {
    value = BROWSER_COLORS[value.toLowerCase()]
  } else if (isRgb(value)) {
    value = rgbToRgb(value, toString);
  } else if (isHex(value)) {
    value = hexToRgb(value, toString);
  } else if (isHsl(value)) {
    value = hslToRgb(value, toString);
  } else {
    throw new Error(`Invalid value for color: ${value}. Must either be rgb (rgb(255,255,255)) or hex (#ffffff)`);
  }
  return value;
};

export const transparentize = (value, amount) => {
  value = normalizeColor(value);
  if (!value) return;

  return `rgba(${value.r}, ${value.g}, ${value.b}, ${parseFloat(value.a) - parseFloat(amount)})`;
};

export const opacify = (value, amount) => {
  value = normalizeColor(value);
  if (!value) return;

  return `rgba(${value.r}, ${value.g}, ${value.b}, ${parseFloat(value.a) + parseFloat(amount)})`;
};

export const setAlpha = (value, alpha) => {
  value = normalizeColor(value);
  if (!value) return;

  return `rgba(${value.r}, ${value.g}, ${value.b}, ${alpha})`;
};

export const lighten = (color, amount = 0, toString = false) => {
  return shadeBlendConvert(Math.abs(amount), normalizeColor(color, true));
};
export const darken = (color, amount = 0, toString = false) => {
  return shadeBlendConvert(-Math.abs(amount), normalizeColor(color, true));
};

export default {
  transparentize: transparentize,
  opacify: opacify,
  lighten: lighten,
  darken: darken,
  hexToRgb: hexToRgb,
  rgbToHex: rgbToHex,
  setAlpha: setAlpha,
  hslToHsl: hslToHsl,
  hslToRgb: hslToRgb,
  isHsl: isHsl,
  isHex: isHex,
  isRgb: isRgb,
  isLight: isLight
};
